import { render } from "./SiteData.vue?vue&type=template&id=c9f1b8c0&scoped=true"
import script from "./SiteData.vue?vue&type=script&lang=js"
export * from "./SiteData.vue?vue&type=script&lang=js"

import "./SiteData.vue?vue&type=style&index=0&id=c9f1b8c0&scoped=true&lang=css"
import "./SiteData.vue?vue&type=style&index=1&id=c9f1b8c0&lang=css"

import exportComponent from "C:\\Users\\Adewale\\OneDrive - kochind.com\\Documents\\zoloscan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9f1b8c0"]])

export default __exports__